import { DocumentType, IAgent, IKnowledge } from '@d-id/types';

export enum AgentPageMode {
    Gallery = 'Gallery',
    Create = 'Create',
    Edit = 'Edit',
}

export enum AgentFileS3UploadStatus {
    Uploading = 'Uploading',
    Uploaded = 'Uploaded',
    Validated = 'Validated',
    Error = 'Error',
}

export const AgentDefaultLanguage = 'English';

interface FileKnowledge extends File {
    type: DocumentType;
}

export interface UploadingFile {
    s3Url?: string;
    status: AgentFileS3UploadStatus;
    file: FileKnowledge;
    error?: string;
    id?: string;
}

export interface InitAgentState extends IKnowledge {
    knowledgeId?: string;
    documents?: UploadingFile[];
    presenter_id?: string;
}

export enum AgentShareActiveTab {
    Embed = 0,
}

export type InputAgent = IAgent;
